"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropsFromChildrenByType = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var is_child_of_type_1 = require("./is-child-of-type");
function getPropsFromChildrenByType(children, component) {
    var props = [];
    var dfs = function (_children) {
        react_1.default.Children.forEach(_children, function (child) {
            if (is_child_of_type_1.isChildOfType(child, component)) {
                props.push(child.props);
            }
            else if (react_1.default.isValidElement(child) &&
                child.props.children) {
                dfs(child.props.children);
            }
        });
    };
    dfs(children);
    return props;
}
exports.getPropsFromChildrenByType = getPropsFromChildrenByType;
//# sourceMappingURL=get-props-from-children-by-type.js.map